import { useEffect, useSyncExternalStore } from "react";

// Lets a page give a URL segment a friendlier breadcrumb label than the
// auto-formatted one (e.g. "EST-1005" → "Job 2918 – Hardie Siding Catalog").
// Header reads the map; pages register labels while mounted.

let labels = {};
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

const subscribe = (l) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

/** Header: current { segment: label } map. */
export const useBreadcrumbLabelMap = () => useSyncExternalStore(subscribe, () => labels);

/** Page: register labels for as long as the component is mounted. */
export const useBreadcrumbLabels = (map) => {
  const key = JSON.stringify(map || {});
  useEffect(() => {
    const entries = JSON.parse(key);
    labels = { ...labels, ...entries };
    emit();
    return () => {
      const next = { ...labels };
      Object.keys(entries).forEach((k) => delete next[k]);
      labels = next;
      emit();
    };
  }, [key]);
};
